export enum RedoCartCheckoutStatus {
  Active = "active",
  Completed = "completed",
  Expired = "expired",
}
